import { Switch, withStyles } from "@material-ui/core";

const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down("md")]: {
      width: 36,
      height: 22,
    }
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: "none",
      },
    },
    "&$disabled": {
      color: theme.palette.grey[400],
      "& + $track": {
        backgroundColor: theme.palette.grey[300],
        opacity: 1,
      },
    },
    "&$checked$disabled": {
      color: "#fff",
      "& + $track": {
        backgroundColor: theme.palette.grey[400],
      },
    },
    "&$focusVisible $thumb": {
      color: "#FFA500",
      border: "6px solid #fff",
    },
  },
  thumb: (props) => ({
    marginTop: 2,
    width: 20,
    height: 20,
    marginLeft: props.marginLeft || 2,
    [theme.breakpoints.down("md")]: {
      width: 15,
      height: 15,
      marginTop: 2,
    }
  }),
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.transitions.create(["background-color", "border"]),
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
    "&:not($checked)": {
      backgroundColor: "grey",
    },
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default CustomSwitch;
